'use client';

import { usePathname } from 'next/navigation';
import { PostHogProvider as _PostHogProvider, usePostHog } from 'posthog-js/react';
import React, { useEffect } from 'react';
import { env } from '~/env.mjs';
import { api } from '~/utils/api';

function Wrapper({ children }: { children: React.ReactNode }) {
  const posthog = usePostHog();
  const { data: authorized } = api.user.authorize.useQuery();
  const pathname = usePathname();

  useEffect(() => {
    authorized && posthog.identify(authorized.user.id, authorized.user);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!!authorized]);

  useEffect(() => {
    posthog.capture('$pageview');
  }, [pathname]);

  return <>{children}</>;
}

export default function PostHogProvider({ children }: { children: React.ReactNode }) {
  if (!env.NEXT_PUBLIC_POSTHOG_API_KEY) return children;

  return (
    <_PostHogProvider
      apiKey={env.NEXT_PUBLIC_POSTHOG_API_KEY}
      options={{
        api_host: env.NEXT_PUBLIC_POSTHOG_API_HOST || 'https://app.posthog.com',
        enable_recording_console_log: true,
        capture_exceptions: true,
        capture_performance: true, // enables $web_vitals
        // Enable session recordings
        disable_session_recording: false,
        session_recording: {
          recordCrossOriginIframes: true,
        },
      }}
    >
      <Wrapper>{children}</Wrapper>
    </_PostHogProvider>
  );
}
